import React, { useContext, useRef, useEffect, useMemo } from 'react';
import { Select, Button, Checkbox, Input, Modal } from 'semantic-ui-react';
import groupService from '../../services/api/groupService';
import { GroupRowColumns } from '../../components/common/rows/GroupRow';
import ViewCoupleGroup from '../../containers/groups/view-couple-group';
import { seminary, eventSlugnameTrim, shuffle, searchSelectProps } from '../../components/helpers';
import Swal from 'sweetalert2';
import ReportButton from '../../containers/admin/ReportButton';
import { ListsContext } from '../../services/contextProviders/lists/listsContext';
import AGTable from 'src/components/table/aggrid';
import { GroupsAdminRow } from 'src/components/common/rows/GroupsAdminRow';
import {
  AdminTableNetworkSection,
  AdminTableContent,
} from 'src/assets/styles/components/AdminTable';
import { screenSizes } from 'src/assets/styles/Literals';

const AdminGroups = (props) => {
  const [loading, set_loading] = React.useState(false);
  const [groups, set_groups] = React.useState([]);
  const [createOpen, set_createOpen] = React.useState(false);
  const [showGroupModal, set_showGroupModal] = React.useState(false);
  const [selectedGroup, set_selectedGroup] = React.useState(null);
  const [inputs, setInputs] = React.useState({ noFilter: true });
  const { groupCategories } = useContext(ListsContext);
  const gridRef = useRef(null);

  const params = props.match.params;
  const kind = params.kind;
  const kindgrouplist =
    (inputs.kindgroup || kind) === 'Grupo_Seminario' ? seminary : groupCategories;

  const onEnter = (e) => {
    if (e.key === 'Enter') {
      getInfo();
    }
  };

  React.useEffect(() => {
    getInfo();
  }, [kind, inputs.activityName, inputs.noFilter]);

  const getInfo = () => {
    const { activityName, noFilter, leaderNameFilter } = inputs;
    set_groups([]);
    if (activityName || noFilter) {
      set_loading(true);
      let body = { activityName, noFilter, kind, leaderNameFilter };
      groupService
        .getAllGroupsByLeader(body)
        .then((response) => {
          if (response.data.success) {
            set_groups(response.data.groups || []);
            set_loading(false);
            onGridReady(gridRef.current);
          }
        })
        .catch((error) => {
          set_loading(false);
          if (error.response) Swal.fire(error.response.data.message);
        });
    }
  };
  const selectHandle = (a, { value, name }) => {
    setInputs({ ...inputs, [name]: value });
  };

  const formSelect = ({ name, label, value, options, handler = selectHandle }) => (
    <Select
      placeholder={label}
      {...searchSelectProps({
        name,
        value,
        handler,
        options: options.map((opt) => {
          return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
        }),
      })}
    />
  );

  const handleInputs = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  const onGridReady = (params) => {
    if (gridRef.current) {
      gridRef.current.api = params.api;
      gridRef.current.columnApi = params.columnApi;
      if (window.innerWidth > screenSizes.tablet) {
        params.api.sizeColumnsToFit();
      }
    }
  };

  useEffect(() => {
    if (gridRef.current) {
      gridRef?.current?.api?.sizeColumnsToFit();
    }
  }, [groups]);

  return (
    <AdminTableNetworkSection>
      <AdminTableContent>
        <h2>{eventSlugnameTrim(params.kind)}</h2>
        <div style={{ padding: '30px 0 0 0' }}>
          <div className="options">
            {!inputs.noFilter && (
              <div className="search-query">
                {formSelect({
                  label: 'Categoría',
                  name: 'activityName',
                  loading: loading,
                  value: inputs.activityName || '',
                  options: kindgrouplist,
                })}
              </div>
            )}
            <Input
              loading={loading}
              name={'leaderNameFilter'}
              onChange={handleInputs}
              value={inputs.leaderNameFilter}
              className={'leaderNameFilter'}
              onKeyPress={onEnter}
              placeholder="Buscar por nombre del líder"
            />
            <div style={{ padding: '5px 0 20px 20px' }} className="md-fullWidth">
              <Checkbox
                label="Mostrar todas las categorías"
                name="noFilter"
                checked={inputs.noFilter}
                toggle
                onClick={() =>
                  setInputs({
                    ...inputs,
                    noFilter: !inputs.noFilter,
                    activityName: inputs.activityName
                      ? inputs.activityName
                      : shuffle(kindgrouplist)[0],
                  })
                }
              />
            </div>
          </div>
          <div style={{ textAlign: 'start' }}>
            <Button onClick={() => set_createOpen(!createOpen)}>Crear Grupo</Button>
            {createOpen && (
              <ViewCoupleGroup
                setOpen={set_createOpen}
                open
                editingInputs={{
                  activityName: inputs.activityName,
                  kindgroup: inputs.kindgroup || params.kind,
                  kind: inputs.kindgroup || params.kind,
                }}
                getInfo={getInfo}
                kindgrouplist={kindgrouplist}
              />
            )}
            {params.kind === 'Grupo_Discipulado' && (
              <Button
                color="black"
                onClick={() => props.history.push('/admin/groups/Grupo_Discipulado/pending')}
              >
                Ver personas pendientes
              </Button>
            )}
            <div>
              <ReportButton
                URL={`/groups/report`}
                fileName={`Grupos Comunidad MDE.xlsx`}
                event="Descarga reporte grupos"
              />
              <ReportButton
                URL={`/groups/get-groups-members-report`}
                fileName={`Miembros de Grupos Comunidad MDE.xlsx`}
                filters={{ allActiveMembers: true }}
                event="Descargar reporte de miembros"
              />
            </div>
          </div>
        </div>
      </AdminTableContent>
      <div>
        <AGTable
          rowData={groups}
          rowHeight={50}
          suppressDragLeaveHidesColumns={false}
          columnDefs={GroupsAdminRow({
            set_selectedGroup,
            set_showGroupModal,
            showCapacity: (inputs.kindgroup || params.kind) === 'Grupo_Seminario',
            showPendingTotals: (inputs.kindgroup || params.kind) === 'Grupo_Discipulado',
          })}
          onGridReady={onGridReady}
          tableRef={gridRef}
        />
      </div>
      {Array.isArray(groups) && groups.length === 0 && !loading && (
        <p>No se encuentra información con estos criterios de búsqueda.</p>
      )}
      {loading && <p>Cargando</p>}
      {showGroupModal && selectedGroup && (
        <GroupMembersModal
          set_showGroupModal={set_showGroupModal}
          selectedGroup={selectedGroup}
          inputs={inputs}
          params={params}
          getInfo={getInfo}
        />
      )}
    </AdminTableNetworkSection>
  );
};

export default AdminGroups;

const GroupMembersModal = (props) => {
  const { set_showGroupModal, selectedGroup, inputs, params, getInfo } = props;
  const gridRef = useRef(null);
  const gridApiRef = useRef(null);

  const isCouples = !!(
    selectedGroup.activityName && selectedGroup.activityName.includes('Parejas')
  );

  const membersColumnDefs = useMemo(
    () =>
      GroupRowColumns({
        isCouples,
        getInfo,
        takeattendance: false,
      }).map((col) => ({
        ...col,
        flex: col.flex ?? 1,
        minWidth: col.minWidth || col.width || 120,
        width: undefined,
      })),
    [isCouples, getInfo]
  );

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    if (gridRef.current) {
      gridRef.current.api = params.api;
      gridRef.current.columnApi = params.columnApi;
    }
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    const api = gridApiRef.current || gridRef.current?.api;
    if (api) {
      // Modal layout settles after open; fit again on next frame
      requestAnimationFrame(() => api.sizeColumnsToFit());
    }
  }, [selectedGroup]);

  return (
    <Modal open onClose={() => set_showGroupModal(false)} size="large">
      <Modal.Header>
        {selectedGroup.groupName}{' '}
        {Boolean(inputs.noFilter)
          ? `- ${selectedGroup.activityName?.split?.('_')?.join?.(' ')}`
          : ''}
      </Modal.Header>
      <Modal.Content>
        <AdminTableContent style={{ minWidth: '100%', width: '100%' }}>
          <div style={{ textAlign: 'end', padding: '0 0 10px 0' }}>
            <a
              target="_blank"
              rel="noreferrer"
              href={`/grupos/lider?phone=${
                selectedGroup.maleLeader
                  ? selectedGroup.maleLeader.phone
                  : selectedGroup.femaleLeader.phone
              }&identification=${
                selectedGroup.maleLeader
                  ? selectedGroup.maleLeader.identification
                  : selectedGroup.femaleLeader.identification
              }&activityName=${selectedGroup.activityName}&kindgroup=${params.kind}`}
            >
              <Button>Ver como líder</Button>
            </a>
          </div>
          <div style={{ width: '100%' }}>
            <AGTable
              rowData={selectedGroup?.GroupMembers?.filter?.((member) => !member.pending) || []}
              rowHeight={50}
              suppressDragLeaveHidesColumns={false}
              columnDefs={membersColumnDefs}
              onGridReady={onGridReady}
              tableRef={gridRef}
            />
          </div>
        </AdminTableContent>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => set_showGroupModal(false)}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};
